/* use-is-mobile — porte de `story-book-dtf/src/lib/use-is-mobile.ts`
 * (28/09/2026), Onda 25 (ver `ROADMAP.md` e
 * `specs/0055-frontend-configuracoes-sidebar-storybook/`).
 *
 * PORTE FIEL — hook puro, sem JSX, sem dependência de primitivo. Consumidor:
 * `Sidebar.tsx` (detecção de mobile pro `Sheet` colapsável). */

import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768

const mql = typeof window === "undefined" ? undefined : window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)

function mediaQueryListener(callback: (event: MediaQueryListEvent) => void) {
  if (!mql) {
    return () => {}
  }

  mql.addEventListener("change", callback)

  return () => {
    mql.removeEventListener("change", callback)
  }
}

function isSmallerThanBreakpoint(): boolean {
  return mql?.matches ?? false
}

function getServerSnapshot(): boolean {
  return false
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(mediaQueryListener, isSmallerThanBreakpoint, getServerSnapshot)
}
